module.exports = __webpack_public_path__ + "img/img2.248e9e11.png";